<template>
  <div class="pagenation" v-if="totalDataCount > 0">
    <ul :class="currentPageNo <= 1 ? 'disabled' : ''">
      <li>
        <a @click.prevent="goPage(1)" v-bind:class="{img_disable: isFirstPage()}">
          <img :src="getImage('component/unit/ic_arrow_d_left.svg')" alt="leftd" width="24px" height="auto" >
        </a>
      </li>
      <li>
        <a @click.prevent="goPage(currentPageNo - 1)" v-bind:class="{img_disable: isFirstPage()}">
          <img :src="getImage('component/unit/ic_arrow_left.svg')" alt="left" width="24px" height="auto" >
        </a>
      </li>
    </ul>
    <ul id="page_list" class="page_list">
      <li
        v-for="pageNo in totalPageCount"
        :key="pageNo"
        :class="pageNo === currentPageNo ? 'choosing_page' : ''"
      >
        <a @click.prevent="goPage(pageNo)">
          {{ pageNo }}
        </a>
      </li>
    </ul>
    <ul :class="currentPageNo >= totalPageCount ? 'disabled' : ''">
      <li>
        <a @click.prevent="goPage(currentPageNo + 1)" v-bind:class="{img_disable: isLastPage()}">
          <img :src="getImage('component/unit/ic_arrow_right.svg')" alt="right" width="24px" height="auto" >
        </a>
      </li>
      <li>
        <a @click.prevent="goPage(totalPageCount)" v-bind:class="{img_disable: isLastPage()}">
          <img :src="getImage('component/unit/ic_arrow_d_right.svg')" alt="rightd" width="24px" height="auto" >
        </a>
      </li>
    </ul>
    <p>
      <i style="color: #FF4500">{{ dataStartIdx }}-{{ dataEndIdx }}</i>&nbsp;of&nbsp;
      {{ totalDataCount ? totalDataCount.toLocaleString() : '0' }}件</p>
  </div>
</template>
<script>
import * as App from '../../utils/App'

/**
 * 親コンポーネントから現在のページ番号を取得するためにはemit用の関数を"callback"として渡すこと
 * <dd-pager
 *   :pageNo="1"
 *   :dataCountPerPage="30"
 *   :totalDataCount="1000"
 *   @callback="someMethod" // @callbackは固定
 * />
 * ・・・
 * someMethod: function (pageNo) {
 *  現在のページ番号がpageNoで渡される
 * }
 */
export default {
  name: 'Pager',
  props: {
    /** ページ番号 */
    pageNo: {
      type: Number,
      default: 1
    },
    /** 1ページあたりの表示件数 */
    dataCountPerPage: {
      type: Number,
      default: 10
    },
    /** 全データ件数 */
    totalDataCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    /** 全ページ数 */
    totalPageCount: function () {
      return this.totalDataCount ? Math.floor((this.totalDataCount - 1) / this.dataCountPerPage) + 1 : 0
    },
    /** 現在のページの最初のデータのインデックス */
    dataStartIdx: function () {
      return (this.currentPageNo - 1) * this.dataCountPerPage + 1
    },
    /** 現在のページの最後のデータのインデックス */
    dataEndIdx: function () {
      let tmp = this.currentPageNo * this.dataCountPerPage
      return tmp > this.totalDataCount ? this.totalDataCount : tmp
    }
  },
  data () {
    return {
      /** 現在のページ番号 */
      currentPageNo: this.pageNo
    }
  },
  watch: {
    pageNo: function () {
      this.goPage(this.pageNo)
    }
  },
  methods: {
    goPage: function (pageNo) {
      if (this.currentPageNo === pageNo) return
      // ページ番号
      if (pageNo < 1) pageNo = 1
      if (pageNo > this.totalPageCount) pageNo = this.totalPageCount
      this.currentPageNo = pageNo
      // スクロール
      this.$nextTick(function () {
        // templateへのデータ反映後(レンダリング後)にスクロール処理を行う
        let ul = document.getElementById('page_list')
        let ulStyle = ul.getBoundingClientRect()
        let ulCenter = ulStyle.left + ulStyle.width / 2
        let li = Array.prototype.slice.call(ul.children)[pageNo - 1]
        let liStyle = li.getBoundingClientRect()
        let liCenter = liStyle.left + liStyle.width / 2
        ul.scrollLeft += liCenter - ulCenter
      })
      // 親コンポーネントへページ番号を通知
      this.$emit('paging', this.currentPageNo)
    },
    /** 現在のページを更新 */
    setCurrentPage: function (pageNo) {
      if (this.currentPageNo === pageNo) return
      // ページ番号
      if (pageNo < 1) pageNo = 1
      if (pageNo > this.totalPageCount) pageNo = this.totalPageCount
      this.currentPageNo = pageNo
    },
    /** 最初のページか判定 */
    isFirstPage: function () {
      if (this.currentPageNo === 1) return true
      return false
    },
    /** 最後のページか判定 */
    isLastPage: function () {
      if (this.currentPageNo === this.totalPageCount) return true
      return false
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  }
}
</script>

<style lang="scss" scoped>
.pagenation {
  max-width: 800px;
  height: 30px;
  margin: 5px 0px 10px auto;;
  padding-left: 25px;
  display: flex;
  justify-content: center;
  p {
    padding: 3px 5px 0px 5px;
    line-height: 30px;
    white-space: nowrap;
    user-select: none;
  }
  ul {
    padding: 0 10px;
    display: flex;
    li {
      display: flex;
      margin-top: 5px;
      a {
        display: block;
        margin: 0px 5px;
        text-align: center;
        line-height: 18px;
        letter-spacing: 1.2px;
        background-image: -webkit-linear-gradient(#fff 0%, #eee 100%);
        background-image: linear-gradient(#fff 0%, #eee 100%);
        text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.8);
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.28);
        cursor: pointer;
        user-select: none;
        &:hover {
          background-image: -webkit-linear-gradient(#ddd 0%, #fff 100%);
          background-image: linear-gradient(#eee 0%, #eee 100%);
          text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.8);
        }
        &:active {
          -ms-transform: translateY(2px);
          -webkit-transform: translateY(2px);
          transform: translateY(2px);
          border-bottom: none;
          background-image: -webkit-linear-gradient(#ddd 0%, #fff 100%);
          background-image: linear-gradient(#eee 0%, #eee 100%);
          text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.8);
          box-shadow: none;
        }
        i {
          padding: 5px 0px 5px 0px;
        }
        img {
          cursor : pointer;
        }
      }
      &.choosing_page a {
        background: #eee;
        background-image: none;
        box-shadow: none;
        color: #FF4500;
        -ms-transform: none;
        -webkit-transform: none;
        transform: none;
        padding-top: 3px;
      }
    }
    &.page_list {
      max-width: calc(100% - 280px);
      overflow: hidden;
    }

    &.disabled {
      a {
        background: #eee;
        cursor: default;
        box-shadow: none;
        color: #bbb;
        &:active {
          transform: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/OrderPager.vue